
import { ReactNode } from "react";
import { Card, CardContent } from "@/components/ui/card";

interface AuthCardProps {
  children: ReactNode;
  animateCard: boolean;
}

export const AuthCard = ({ children, animateCard }: AuthCardProps) => {
  return (
    <Card className={`overflow-hidden shadow-lg border-primary/10 relative ${animateCard ? 'scale-[0.98] opacity-90' : 'scale-100 opacity-100'} transition-all duration-300`}>
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary via-primary/70 to-primary"></div>
      <CardContent className="p-6 sm:p-8 pt-8">
        {children}
      </CardContent>
    </Card>
  );
};
